<template>
  <div class="h-100 d-flex align-center">
    <template v-if="!$store.state.dialerV2.reconnecting">
      <div class="text-xs-center">
        <template v-if="$store.state.dialerV2.status !== 3">
          <img src="@/assets/img/call_center_wait_logo.svg" class="loading-logo mb-4"/>
          <h2 class="loading-text">
            Localizando clientes
          </h2>
          <h3 v-if="$store.state.dialerV2.status === 1" class="mt-3 mr-3 timer">
            <strong>
              <v-icon small class="mb-1">
                fas fa-clock
              </v-icon>
              <span>
                {{ timer }}
              </span>
            </strong>
          </h3>
          <span></span>
        </template>
        <incoming-call v-else-if="$store.state.dialerV2.currentCall.type_id === 9 || !$store.state.dialerV2.currentCall.customer_id"/>
      </div>
    </template>
    <v-snackbar
      v-else
      v-model="$store.state.dialerV2.reconnecting"
      :bottom="true"
      :timeout="0"
      top
      absolute>
      Perdida de conexion con el servidor de llamadas, reconectando...
    </v-snackbar>
  </div>
</template>

<script>
import IncomingCall from './IncomingCall';

import EventBus from '@/event-bus';
import dialerV2 from '@/store/dialer_v2';

const routeHandler = (to, from, next) => {
  if (dialerV2.state.status === 1) {
    return next();
  }

  let { name = 'CallList' } = from;
  if (!name) {
    name = 'CallList';
  } else if (name === 'CallCenterWaitV2') {
    name = 'CallList';
  }
  return next({
    name,
  });
};

import timerMixin from '@/mixins/timer';

export default {
  mixins: [
    timerMixin,
  ],
  beforeRouteEnter: routeHandler,
  beforeRouteUpdate: routeHandler,
  beforeRouteLeave(to, from, next) {
    if (
      !this.$store.state.dialerV2.status
      || (
        to.name === 'CustomerShow'
        && this.$store.state.dialerV2.status === 3
        && (
          this.$store.state.dialerV2.currentCall.type_id !== 7
          || this.$store.state.dialerV2.currentCall.customer_id
        )
      )
    ) {
      return next();
    }

    EventBus.$emit('modal', 'No puede abandonar esta pestaña mientras este conectado.');
    return next(false);
  },
  components: {
    IncomingCall,
  },
  computed: {
    currentStatusStartTime() {
      return this.$store.state.callTimeAndAlert.currentStatusStartTime;
    },
  }, 
  mounted() {
    EventBus.$emit('hideMenu');
  },
};
</script>

<style scoped>
@keyframes growShrink {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}
@keyframes dots {
  0%, 12.5% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    text-shadow: .5em 0;
  }
  75% {
    text-shadow: .5em 0, 1em 0;
  }
}
.loading-logo {
  animation: growShrink 2s infinite alternate;
}
.loading-text::after {
  content: ' .';
  animation: dots 2s steps(1, end) infinite;
}

.timer {
  color: #91929E !important;
  font-size: 18px;
}
.timer i {
  margin-right: 10px;
  font-size: 20px !important;
  color: #91929E !important;
  margin-top: 1px;
}
.loading-text span {
  width: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/CallCenter/WaitV2.vue